import React from 'react';
import { Navigate } from 'react-router';
import { useAdmin } from '../context/AdminContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, adminUser, logout } = useAdmin();

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (adminUser && !['admin', 'super_admin'].includes(adminUser.role)) {
    logout();
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
